import React from "react";
import ReactDOM from "react-dom";
import CustomButton from "./components/CustomButton";
import AboutMe from "./components/AboutMe";
import "./index.css";

const App = () => {
  return (
    <div>
      <div className="center-align">
        <h1 className="Title">
          Ohad Katz
        </h1>

        <h5 className="info">Senior Systems Development Engineer at AWS</h5>
        
        <div className="container">
          <div className="border">
            <CustomButton
              btnName="resume"
              link="/resume.pdf"
              target="_blank"
            />
            <CustomButton 
              btnName="github" 
              link="https://github.com/ohadkatz" 
              target="_blank"
            />
            <CustomButton
              btnName="linkedin"
              link="https://www.linkedin.com/in/ohadkatz/"
              target="_blank"
            />
          </div>
        </div>
        
        <AboutMe />
      </div>
    </div>
  );
};

ReactDOM.render(<App />, document.querySelector("#root"));
